import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

import { Root as SelectPrimitiveRoot } from "@radix-ui/react-select";
import { cn } from "@/lib/utils";
import { isPrimitive } from "helper/utils";
import { useMemo, forwardRef, ComponentProps } from "react";

export type OptionType = {
  value: string;
  label: string;
};
export type DropdownSelectProps = {
  options: string[] | OptionType[];
  placeholder?: string;
  defaultValue?: string | null;
  className?: string;
  value?: string;
  onValueChange?: (value: string) => void;
  "aria-invalid"?: boolean | "true" | "false";
  "aria-describedby"?: string;
} & ComponentProps<typeof SelectPrimitiveRoot>;

export const DropdownSelect = forwardRef<HTMLDivElement, DropdownSelectProps>(
  ({ options, placeholder, className, value = "", onValueChange, ...selectProps }, ref) => {
    const optionData = useMemo(
      () =>
        options.map(
          (opt) =>
            (isPrimitive(opt)
              ? {
                  value: opt,
                  label: String(opt),
                }
              : opt) as OptionType,
        ),
      [options],
    );

    const { "aria-invalid": ariaInvalid, "aria-describedby": ariaDescribedby, ...restSelectProps } = selectProps;

    return (
      <Select value={value} onValueChange={onValueChange} {...restSelectProps}>
        <SelectTrigger
          className={cn("w-40 bg-white", className)}
          aria-invalid={ariaInvalid}
          aria-describedby={ariaDescribedby}
        >
          <SelectValue placeholder={placeholder} ref={ref} />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {optionData.map((item) => (
              <SelectItem value={String(item.value)} key={`select-${item.value}`} className="cursor-pointer">
                {item.label}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    );
  },
);

DropdownSelect.displayName = "DropdownSelect";
